import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import {
  BlockHeader,
  PUBLICATION_BLOCK_SX,
} from '../../Map/components/DockPanel/Tabs/formBlockUi';
import PlanimetriaSection from '../../Map/components/DockPanel/Tabs/PlanimetriaSection';
import { cadFeatureToPlanimetriaBoundary } from '../utils/cadGeometry';

/**
 * Planimetría de una parcela CAD. Reusa el SVG/cotas del detalle de lote
 * (`PlanimetriaSection`); el unique CAD es el adapter a `boundary`.
 */
export default function ShowroomParcelPlanimetria({ feature }) {
  const boundary = useMemo(
    () => cadFeatureToPlanimetriaBoundary(feature),
    [feature],
  );
  const declaredSurfaceM2 = Number(feature?.properties?.area_m2);
  if (boundary.length < 3) return null;

  return (
    <Box sx={{ ...PUBLICATION_BLOCK_SX, p: 1.5, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <BlockHeader title="Planimetría" />
      <PlanimetriaSection
        hideTitle
        hideLotShape
        boundary={boundary}
        declaredSurfaceM2={Number.isFinite(declaredSurfaceM2) ? declaredSurfaceM2 : null}
      />
    </Box>
  );
}
